import { apiGet, apiPut } from "@redriver/cinnamon";

const NAMESPACE = "FUNDER_TYPE_SETTINGS";

export const ActionTypes = {
  GetFunderTypeSettings: `${NAMESPACE}/GET`,
  UpdateFunderTypeSettings: `${NAMESPACE}/PUT`,
};

export const getFunderTypeSettings = ({
  settingsId,
  funderType,
  calcTableType,
}) => {
  return settingsId
    ? apiGet(
        ActionTypes.GetFunderTypeSettings,
        `funder-type-settings/${settingsId}`,
        { funderType, calcTableType },
      )
    : {};
};

export const updateFunderTypeSettings = (
  formData,
  { settingsId, funderType, calcTableType },
) => {
  return apiPut(
    ActionTypes.UpdateFunderTypeSettings,
    `funder-type-settings/${settingsId}`,
    { funderType, calcTableType, ...formData },
  );
};
